import * as types from "./mutation-type";
import api from "@/modules/api";

const actions = {
  async updateShiftPrioritySettings({ commit, rootState }, data ) {
    try {
      commit(types.UPDATE_SHIFT_PRIORITY_SETTINGS_BEGIN);
      await api.store.update(rootState.app.Store.id, { shiftPrioritySettings : data })
      commit(types.UPDATE_SHIFT_PRIORITY_SETTINGS_SUCCESS);
    } catch (e) {
      commit(types.UPDATE_SHIFT_PRIORITY_SETTINGS_ERROR, e);
    }
  }
};
export default actions;
